import { useInfiniteQuery } from '@tanstack/react-query'
import {
  getCreatedBoxes,
  CreatedBoxesOrderBy,
  CreatedBoxesOrderDirection,
} from '../api/userApi'
import { useAppContext } from '../contexts/App.context'
import { DEFAULT_PAGINATION } from '../api/boxApi'
import { useEffect } from 'react'

export interface UseCreatedBoxesParams {
  orderBy?: CreatedBoxesOrderBy
  orderDirection?: CreatedBoxesOrderDirection
  limit?: number
}

export const useCreatedBoxes = (params: UseCreatedBoxesParams = {}) => {
  const { canFetchUserData } = useAppContext()
  const { orderBy, orderDirection, limit = DEFAULT_PAGINATION.limit } = params

  const query = useInfiniteQuery({
    queryKey: ['createdBoxes', orderBy, orderDirection, limit],
    queryFn: ({ pageParam = 1 }) =>
      getCreatedBoxes({ orderBy, orderDirection, page: pageParam, limit }),
    getNextPageParam: lastPage => {
      if (lastPage.meta.totalPages <= lastPage.meta.page) {
        return undefined
      }
      return lastPage.meta.page + 1
    },
    initialPageParam: 1,
    enabled: canFetchUserData,
  })

  // Log when canFetchUserData changes to help debug
  useEffect(() => {
    console.log(
      'useCreatedBoxes: canFetchUserData changed to',
      canFetchUserData,
    )
    if (canFetchUserData && !query.isFetching && !query.data) {
      console.log('useCreatedBoxes: Triggering refetch')
      query.refetch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canFetchUserData])

  return query
}
